import * as React from 'react';

import * as Edge from '../../core';
import RedirectExternal from '.';

const BlockRegistration: React.FunctionComponent = (props) => (
	<RedirectExternal to={Edge.Constants.URL_REGISTER_NO_SKU} />
);
export default BlockRegistration;
